export default {
  app: {
    title: 'TimeOnline',
    admin: {
      listing: {
        labels: {
          userEmail: 'User Email',
          emailSubject: 'Email Subject',
          sentAt: 'Sent At',
          message: 'View Message'
        }
      }
    },
    navigation: {
      menu: 'Menu',
      dashboard: 'Dashboard',
      changes: 'Changes',
      reports: 'Reports',
      admin: 'Admin',
      records: 'Records',
      placementActivity: 'Placement Activity',
      advancedSearch: 'Advanced Search',
      assignments: 'Assignments',
      permPlacements: 'Permanent Placements',
      timeSheets: 'Time Sheets',
      expenses: 'Expenses',
      payrollOverviews: 'Payroll Overviews',
      contractors: 'Contractors',
      clients: 'Clients',
      clientContacts: 'Client Contacts',
      purchaseOrders: 'Purchase Orders',
      suppliers: 'Suppliers',
      supplierContacts: 'Supplier Contacts',
      tesEmployees: 'TES Employees',
      users: 'Users',
      recent: 'Recent',
      more: 'More',
      help: 'Help',
      userGuides: 'User Guides',
      emailSupport: 'Email Support (support@timeonline.com)',
      profile: 'Profile',
      preferences: 'Preferences',
      logout: 'Logout',
      quickSearch: 'Quick Search',
      depositSlips: 'Deposit Slips',
      home: 'Home',
      english: 'en',
      french: 'fr'
    },
    homePage: {
      welcome: 'Hi {userName}, welcome to TimeOnline!',
      lastLogin: 'Last logged in at:',
      firstLogin: 'This is your first time logging in',
      pageDisplays: 'This page dispalys all {displayTypes} {displayObjects}',
      unreadCount: 'You have {count} unread notifications',
      displays: 'This page dispalys all',
      sysAdminBlurb: 'recent (non system generated) activity',
      title: 'Home',
      listing: {
        labels: {
          contractor: 'Contractor',
          client: 'Client',
          startDate: 'Start',
          endDate: 'End',
          totalHours: 'Hours',
          totalDays: 'Days',
          status: 'Status',
          totalAmount: 'Amount'
        }
      }
    },
    pageFooter: {
      forHelp: 'Need Help? email ',
      supportEmail: 'support@timeonline.com',
      copyright: 'Copyright',
      copyrightAddress: 'https://www.tes.net/',
      copyrightName: 'The Employment Solution',
      copyrightYears: `${new Date().getFullYear()}`
    },
    help: {
      title: 'Help Page',
      forgotUsername: 'Forgot Your Username?',
      forgotPassword: 'Forgot Your Password?',
      forgotUsernameBlurb:
        "Enter the email address we send your notifications to. We'll send your username.",
      forgotPasswordBlurb:
        'Enter the username you use to sign into your account, or your emaill address',
      forgotPwDefault: 'Email address or username',
      forgotUsernameDefault: 'Enter your email address',
      changeRequestSuccessMessage:
        'Check your inbox. Please use the link we sent you to reset your password.',
      changeRequestErrorMessage: 'Sorry, we do not have any record of that {usernameOrEmail}',
      passwordChangeSuccess:
        'Your password has been changed. Return to login page and sign in with your new password',
      passwordChangeError: 'Oops, something went wrong. Referesh this page and try again.'
    }
  },
  login: {
    userName: 'USERNAME',
    password: 'PASSWORD',
    pleaseLogIn: 'Login',
    passwordReset: 'Password Reset',
    submit: 'Log In',
    errors: {
      badCredentials: 'Could not log in. Either username or password are incorrect',
      loginAgain: 'Your session has timed out, please log in again',
      loginFirst: 'You must log in first'
    }
  },
  components: {
    select: {
      defaults: {
        placeholder: 'Choose...',
        multiSelectLabel: 'Selected'
      }
    },
    tolErrors: {
      defaults: {
        message: '| There is 1 error | There are {count} errors'
      },
      moreItems: '|| ...and {count} more errors'
    },
    confirmModal: {
      defaults: {
        message: 'Are you sure you want to continue?',
        continue: 'Continue',
        cancel: 'Cancel',
        comment: 'Comment',
        okay: 'Okay',
        yes: 'Yes',
        no: 'No'
      }
    },
    updateModal: {
      firstApplicationAccess: {
        '1': 'This is the first time you are accessing this version of the application.',
        '2':
          'You are required to reset your password. Please check your email for a link sent from us, and use that link to reset your password.',
        '3':
          'If you have any issues resetting your password, please contact support at: support@timeonline.com'
      },
      accountNotVerified: {
        '1':
          'Please check your email for a one-time passcode we have sent. Enter your code in the spaces below.',
        '2': 'Your one-time passcode will expire in 24 hours.',
        '3': 'If you encounter any issues, please contact support at: support@timeonline.com'
      },
      accountUser: 'Hi {firstname}, your account has not yet been verified.',
      welcome: 'Welcome to TimeOnline'
    }
  },
  timeSheet: {
    actions: {
      saveAsPdf: 'Save as PDF',
      save: 'Save',
      submit: 'Submit',
      approve: 'Approve',
      reject: 'Reject',
      reopen: 'Re-Open',
      viewExpense: 'View Expense',
      createExpense: 'Create Expense',
      process: 'Process'
    },
    labels: {
      timeSheet: 'Time Sheet',
      referenceNumber: 'Reference Number',
      status: 'Status',
      contractor: 'Contractor',
      client: 'Client',
      assignment: 'Assignment',
      approvers: 'Approvers',
      comment: 'Comment',
      period: 'Period',
      endClient: 'End Client',
      payrollNumber: 'Payroll Number',
      branch: 'Branch',
      notes: 'Notes',
      none: 'None',
      purchaseOrderLineItems: 'PO Line Items',
      rateCode: 'Rate Code',
      amountRemaining: 'Funds Remaining',
      quantityRemaining: 'Hours Remaining'
    },
    placeholders: {
      commentsPlaceholder: 'Type your general comments here'
    }
  },
  timeSheets: {
    listing: {
      title: 'Time Sheets',
      actions: {
        titleAll: 'All Time Sheets',
        titleFiltered: 'Filtered Time Sheets',
        titleYour: 'Your Time Sheets',
        view: 'View',
        exportToXlsx: 'Export To XLSX'
      },
      labels: {
        referenceNumber: 'Reference Number',
        payrollNumber: 'Payroll #',
        assignment: 'Assignment',
        client: 'Client',
        contractor: 'Contractor',
        startDate: 'Start',
        endDate: 'End',
        totalHours: 'Hours',
        totalDays: 'Days',
        status: 'Status',
        modifiedBy: 'Modified By',
        approveTimeSheets: 'Approve Time Sheets',
        rejectTimeSheets: 'Reject Time Sheets',
        bulkPdf: 'Bulk PDF',
        comment: 'Comment'
      },
      filters: {
        title: 'Filter Time Sheets',
        startRange: 'Start Range',
        endRange: 'End Range',
        dateRangeLabel: 'End Date is between',
        assignment: {
          all: 'All Assignments'
        },
        contractor: {
          all: 'All Contractors'
        },
        status: {
          all: 'All Statuses',
          plural: 'Statuses'
        }
      },
      noResultsMessage: 'There are no time sheets that match the filters.',
      alertMessage:
        'You have no time sheets in {status} status | You have 1 time sheet in {status} status | You have {count} time sheets in {status} status',

      dialogs: {
        rejectTimeSheetsConfirmationDialog: {
          title: 'Reject Time Sheets',
          content: 'Do you wish to reject these selected time sheets?'
        },
        bulkApproveRejectConfirmationDialog: {
          confirmMessage: 'Are you sure you want to {message} this batch of time sheets?',
          continue: 'Continue',
          cancel: 'Cancel'
        }
      },
      errors: {
        retrieveTimeSheets: 'There was an error retrieving the list of time sheets',
        retrieveAssignments: 'There was an error retrieving the list of assignments for filtering',
        retrieveContractors: 'There was an error retrieving the list of contractors for filtering',
        retrieveStatusCount: 'There was an error retrieving the status count',
        bulkApproveRejectDisallowed:
          'This action is not allowed on one or more of the selected timesheets',
        bulkApproveRejectFailed: 'There was an error updating the timesheets'
      }
    },
    details: {
      editTitle: 'Edit Time Sheet',
      reviewTitle: 'Review Time Sheet',
      timeSheet: 'Time Sheet',
      endClientConfirm: 'End Client',
      errors: {
        retrieveTimeSheet: 'There was an error loading the time sheet from the sever',
        retrieveAttachments:
          "There was an error loading the time sheet's attachments from the sever",
        save: 'There was an error saving the time sheet',
        reopen: 'There was an error re-opening the time sheet',
        approverAction: 'There was an error completing that action',
        commentMandatory: 'Comment is mandatory when rejecting a time sheet',
        expense: 'There was an error retrieving or creating the expense report',
        confirmIbmEndClient: 'You must either confirm or replace end client',
        timeSheetHistory: 'There was an error retrieving the history records',
        hoursNotNumeric: 'Please enter valid hours',
        hoursGreatherThanTwentyFourOrLessThanZero: 'Please enter valid hours'
      },
      showHistory: 'Show history records',
      hideHistory: 'Hide history records'
    },
    history: {
      title: 'History',
      version: 'Version {num}'
    }
  },
  attachments: {
    title: 'Attachments',
    labels: {
      invoice: 'Invoice',
      other: 'Other',
      drop: 'Drop your file here or ',
      select: 'select from your computer',
      selectOnly: 'Select a file from your computer',
      allowedFiles: 'pdf, xlsx, docx, jpg, gif, png, tif, zip'
    },
    confirmDelete: 'Please confirm if you would like to delete the selected attachment',
    confirmDeleteTitle: 'Confirm deleting the Attachment',
    errors: {
      forbiddenView: 'You do not have permission to view this attachment',
      forbiddenDelete: 'You do not have permission to delete this attachment',
      notFound: 'Attachment not found',
      uploadFailed: 'Failed to attach files',
      unexpected: 'Unexpected error {status}',
      unsupported: 'Unsupported file type',
      categoryNotSelected: 'Please select an attachment category'
    },
    uploadedBy: 'Uploaded by {name} at {date}'
  },
  expense: {
    actions: {
      saveAsPdf: 'Save as PDF',
      save: 'Save',
      submit: 'Submit',
      approve: 'Approve',
      reject: 'Reject',
      reopen: 'Re-Open',
      add: 'Add Entry',
      process: 'Process'
    },
    labels: {
      expense: 'Expense',
      referenceNumber: 'Reference Number',
      status: 'Status',
      contractor: 'Contractor',
      client: 'Client',
      assignment: 'Assignment',
      approvers: 'Approvers',
      comment: 'Comment',
      period: 'Period',
      payrollNum: 'Payroll Number'
    },
    placeholders: {
      commentsPlaceholder: 'Type your general comments here',
      selectDate: 'Select Date'
    },
    errors: {
      amountNotNumeric: 'Amount must be numeric',
      approverAction: 'There was an error completing that action',
      retrieveExpense: 'There was an error loading the expense report from the server',
      retrieveAttachments:
        "There was an error loading the expense report's attachments from the server",
      save: 'There was an error saving the expense report',
      reopen: 'There was an error re-opening the expense report',
      commentMandatory: 'Comment is mandatory when rejecting an expense report',
      expense: 'Failed to generate or retrieve an expense report',
      invalidEntries: 'Some entries are missing date or non zero amount',
      retrieveHistory: 'There was an error retrieving the history records'
    },
    history: {
      title: 'History',
      version: 'Version {num}'
    }
  },
  expenses: {
    listing: {
      title: 'Expenses',
      actions: {
        titleAll: 'All Expenses',
        titleFiltered: 'Filtered Expenses',
        titleYour: 'Your Expenses',
        view: 'View',
        exportToXlsx: 'Export To XLSX'
      },
      labels: {
        referenceNumber: 'Reference Number',
        payrollNumber: 'Payroll #',
        assignment: 'Assignment',
        client: 'Client',
        clientName: 'Client' /*temporary fix to solve I18n warnings */,
        contractor: 'Contractor',
        startDate: 'Start',
        endDate: 'End',
        totalAmount: 'Amount',
        status: 'Status',
        approveExpenses: 'Approve Expenses',
        rejectExpenses: 'Reject Expenses',
        bulkPdf: 'Bulk PDF'
      },
      filters: {
        title: 'Filter Expenses',
        startRange: 'Start Range',
        endRange: 'End Range',
        dateRangeLabel: 'End Date is between',
        assignment: {
          all: 'All Assignments'
        },
        contractor: {
          all: 'All Contractors'
        },
        status: {
          all: 'All Statuses',
          plural: 'Statuses'
        }
      },
      noResultsMessage: 'There are no expenses that match the filters.',
      alertMessage:
        'You have no expenses in {status} status | You have 1 expense in {status} status | You have {count} expenses in {status} status',
      errors: {
        retrieveExpenses: 'There was an error retrieving the list of expenses',
        retrieveAssignments: 'There was an error retrieving the list of assignments for filtering',
        retrieveContractors: 'There was an error retrieving the list of contractors for filtering',
        retrieveStatusCount: 'There was an error retrieving the status count'
      }
    },
    details: {
      editTitle: 'Edit Expense',
      reviewTitle: 'Review Expense',
      expense: 'Expense',
      dropLabel: 'Drop you file here or ',
      selectLabel: 'select from your computer',
      selectOnlyLabel: 'Select a file from your computer',
      errors: {
        commentMandatory: 'Comment is mandatory when rejecting an expense report'
      },
      showHistory: 'Show history records',
      hideHistory: 'Hide history records'
    }
  },
  suppliers: {
    labels: {
      attachment: 'Attachment',
      history: 'History',
      contacts: 'Contacts',
      contractors: 'Contractors',
      details: 'Details',
      addresses: 'Addresses',
      newSupplier: 'New Supplier'
    },
    contractors: {
      payroll_number: 'Payroll#',
      name: 'Name',
      entity: 'Entity',
      pay_to_name: 'Pay To Name',
      email: 'Email',
      referenceNumber: 'Reference Number'
    },
    contacts: {
      referenceNumber: 'Reference Number',
      contactName: 'Name',
      supplierName: 'Supplier',
      email: 'Email',
      phone: 'Phone'
    },

    filterPreference: {
      active: 'Active',
      inactive: 'Inactive',
      both: 'Both'
    },
    listing: {
      title: 'Suppliers',
      all: 'All Suppliers',
      errors: {
        retrieveSuppliers: 'There was an error retrieving the list of Suppliers'
      },
      labels: {
        name: 'Name',
        defaultAddress: 'Default Address',
        heldCheque: 'Held Cheques for Clients',
        referenceNumber: 'Reference Number'
      },
      filters: {
        title: 'Filter Suppliers',
        all: 'Select Suppliers'
      },
      actions: {
        new: 'New Supplier',
        exportToExcel: 'Export to Excel',
        exportAll: 'Export All',
        exportPage: 'Export this page'
      }
    },
    details: {
      errors: {
        retrieveSupplier: 'There was an error retrieving the list of Suppliers'
      },
      title: 'Suppliers',
      name: 'Supplier Name',
      clientName: 'Clients Held Cheques',
      gst: 'GST',
      qst: 'QST',
      hst: 'HST',
      is_active: 'Active',
      updateSuccess: 'Supplier details updated updated successfully'
    }
  },
  bulk: {
    dialogs: {
      approveRejectConfirmationDialog: {
        confirmMessage: 'Are you sure you want to {message} this batch of selected items?',
        continue: 'Continue',
        cancel: 'Cancel',
        okay: 'Okay'
      }
    },
    labels: {
      totalSelected: 'Total Selected'
    },
    actions: {
      approve: 'Approve',
      reject: 'Reject',
      saveAsPdf: 'Save as PDF'
    },
    errors: {
      approveRejectDisallowed: 'This action is not allowed on one or more of the selected items',
      approveRejectFailed: 'There was an error updating the items',
      sameClientError: 'Selected {item} should be for the same client'
    }
  },
  notifications: {
    listing: {
      title: 'Notifications',
      listingTitle: 'Notifications',
      noNotificationMessage: 'You do not have any notifications',
      labels: {
        timeGenerated: 'Time Generated',
        generatedBy: 'Generated By',
        message: 'Message',
        referenceNumber: 'Reference Number'
      },
      errors: {
        retrieveNotifications: 'There was an error retrieving notifications',
        updateNotifications: 'There was an error updating notifications'
      }
    }
  },
  preferences: {
    listing: {
      title: 'Preferences',
      userTitle: 'Notification Preferences for {username}',
      subTitle: 'Set Notification Preferences',
      noPreferencesMessage: 'You have no notification preferences set',
      labels: {
        object: 'Object',
        action: 'Action',
        noticeType: 'Notice Type',
        inApp: 'Notify in TimeOnline',
        email: 'Send an Email',
        labelStarter: 'Notify me when',
        is: 'is',
        for: 'for',
        label: 'Notice Type'
      }
    },
    errors: {
      retrievePreferences: 'There was an error retrieving preference settings',
      updatePreferences: 'There was an error updating preference settings',
      addPreference: 'There was an error creating preference settings'
    }
  },
  profile: {
    errors: {
      updateError: 'There was an error updating user profile',
      usernameBlankError: 'Username cannot be blank',
      usernameTooShort: 'Please enter a username with 3 or more characters'
    },
    titles: {
      title: 'User Profile',
      action: 'Action',
      item: 'Item',
      referenceNum: 'Reference #',
      userDetails: 'User Details',
      recentlyAccessed: 'Recently Accessed',
      recentActions: 'Recent Actions',
      recentlyViewed: 'Recently Viewed',
      type: 'Type',
      timestamp: 'Timestamp',
      ipAddress: 'IP Address'
    },
    labels: {
      userName: 'Username',
      roles: 'Roles',
      email: 'Email',
      password: 'Password',
      altEmail: 'alt. email',
      phones: 'Phones',
      branch: 'Branch',
      payto: 'Pay To',
      payroll: 'Payroll #',
      entity: 'Entity',
      impersonate: 'impersonate',
      inactiveUser: 'User is inactive and will not be able to log in',
      notifications: 'Notifications',
      preferences: 'Preferences',
      sendChangeInstructions: 'Send password change instructions',
      changeSent: 'A password reset link has been emailed to this user'
    },
    listing: {
      labels: {
        initiatedAt: 'Initiated At',
        objectType: 'Object Type',
        action: 'Action',
        ipAddress: 'IP Address'
      }
    }
  },
  pagination: {
    labels: {
      perPage: 'Records per page',
      showing: 'Showing',
      of: 'of'
    }
  },
  assignment: {
    labels: {
      details: 'Details',
      contractorDetails: 'Contractor',
      clientDetails: 'Client',
      stakeholdersDetails: 'Stakeholders',
      miscDetails: 'Misc',
      timeSheets: 'Time Sheets',
      expenses: 'Expenses',
      attachments: 'Attachments',
      history: 'History',
      ibmExtraInfo: 'Extra Info for IBM',
      extraInfo: 'Extra Info',
      comments: 'Comments',

      formLabels: {
        phone: 'Phone',
        email: 'Email',
        payrollNumber: 'Payroll #',
        hst: 'HST',
        backcheck: 'Backcheck',
        payTo: 'Pay to',
        entity: 'Entity',
        clientNumber: 'Client #',
        endClient: 'End Client',
        workOrderNumber: ' Work Order #',
        workAuthorization: 'WA',
        billTo: 'Bill to',
        workLocation: 'Work Location',
        poWo: 'Work Order | Purchase Order',
        approvers: 'Approvers',
        accountManagers: 'Account Managers',
        viewers: 'Viewers',
        recruiters: 'Recruiters',
        users: 'Users',
        commissionOverrides: 'Commission Overrides',
        startDate: 'Start Date',
        endDate: 'End Date',
        submittalPeriod: 'Submittal Period',
        payPeriod: 'Pay Period',
        rebate: 'Rebate',
        burden: 'Burden',
        branch: 'Branch',
        division: 'Division',
        department: 'Department',
        occupation: 'Occupation',
        payStubsOnline: 'Pay Stubs Online',
        timeSheetsSubmittal: 'Time Sheets Submittal',
        expensesSubmittal: 'Expenses Submittal',
        referral: 'Referral',
        rates: 'Rates',
        rateType: 'Rate Type',
        payRate: 'Pay Rate',
        billRate: 'Bill Rate',
        hourRange: 'Hour Range',
        effectiveDate: 'Effective Date',
        submittalPeriodEffectiveDate: 'Submittal Period Change Effective Date',
        hiringManager: 'Hiring Manager',
        scheduleF: 'Schedule F',
        assets: 'Assets',
        assetNumbers: 'Asset Numbers',
        endReasons: 'Reasons',
        ibmExtraInfo: 'Extra Info for IBM',
        hireType: 'Hire Type',
        skillType: 'Skill Type',
        servicesType: 'Services Type',
        referralStatus: 'Referral Status',
        WOs_POs: 'WOs & POs',
        billingComments: 'Billing Comments',
        paymentComments: 'Payment Comments',
        generalComments: 'General Comments',
        createdComments: 'Created Comments',
        purchaseOrderEffectiveDate: 'Effective Date',
        payrollee: 'Payrollee',
        csaSow: 'CSA / SOW?',
        csaRrf: 'CSA / RRF'
      },
      validation: {
        setStartDateBeforeEffective:
          'Set start date on assignment before assigning an effective date',
        effectiveEarlierThanStartDate:
          'Effective date cannot be earlier that assignment start date',
        effectiveOutsideAssignmentDates: 'Effective date cannot be ouside the assignment dates',
        required: 'The {field} field is required',
        accountManagerRequired: 'At least one account manager is required',
        recruiterRequired: 'At least one recruiter is required'
      }
    },
    history: {
      listing: {
        labels: {
          created_at: 'Modified Date',
          created_by_name: 'Modified By',
          status: 'Status',
          created_comment: 'Comment'
        }
      }
    },
    details: {
      title: 'Assignment',
      errors: {
        retrieveAssignment: 'There was an error retrieving the assignment',
        noAssignment: 'No assignment has been selected',
        processAssignment: 'ACTION FORBIDDEN: {message}',
        noRecords: 'There are no {record} for this assignment'
      },
      actions: {
        saveAsPdf: 'Save as PDF'
      }
    }
  },
  assignments: {
    listing: {
      title: 'Assignments',
      labels: {
        referenceNumber: 'Reference Number',
        payrollNumber: 'Payroll Number',
        clientName: 'Client',
        contractorName: 'Contractor',
        startDate: 'Start',
        stopDate: 'Stop',
        approvers: 'Approvers',
        branch: 'Branch',
        status: 'Status',
        approveAssignments: 'Approve Assingments',
        rejectAssignments: 'Reject Assignments',
        bulkPdf: 'Bulk PDF',
        createTimesheet: 'Create New Timesheet',
        showTimeSheets: 'Show Time Sheets',
        hideTimeSheets: 'Hide Time Sheets',
        showExpenses: 'Show Expenses',
        hideExpenses: 'Hide Expenses',
        showAttachments: 'Show Attachments',
        hideAttachments: 'Hide Attachments',
        showHistory: 'Show History Records',
        hideHistory: 'Hide History Records'
      },
      filters: {
        title: 'Filter Assignments',
        startsBetweenLabel: 'Starts Between',
        startDateMin: 'Range Start',
        startDateMax: 'Range End',
        stopsBetweenLabel: 'Stops Between',
        stopDateMin: 'Range Start',
        stopDateMax: 'Range End',
        status: {
          all: 'All Statuses',
          plural: 'Statuses'
        }
      },
      actions: {
        titleAll: 'All Assignments',
        titleFiltered: 'Filtered Assignments',
        exportToXlsx: 'Export To XLSX'
      },
      errors: {
        retrieveAssignments: 'There was an error retrieving the list of assignments',
        bulkApproveRejectFailed: 'There was an error updating the assignments'
      },
      newAssignment: {
        title: 'New Assignment'
      }
    }
  },
  statuses: {
    draft: 'Draft',
    submitted: 'Submitted',
    approved: 'Approved',
    processed: 'Processed',
    rejected: 'Rejected',
    obsolete: 'Obsolete',
    active_online: 'Active Online',
    active_offline: 'Active Offline',
    finished: 'Finished',
    cancelled: 'Cancelled',
    expired: 'Expired',
    received: 'Received'
  },
  dropdown: {
    noResult: 'No Results'
  },
  permPlacement: {
    details: {
      title: 'Permanent Placement',
      errors: {
        npPerm: 'No Permanent Placement',
        retrievePermPlacement: 'Error retrieving permenent placement',
        userAlreadyAdded: '{user} {commission} already added',
        originalDateAfterStart: 'The Orignal Start Date cannot be later than the Start Date',
        startDateBeforeOriginal: 'The Start Date cannot be before the Original Start Date'
      }
    },
    labels: {
      details: 'Details',
      candidatePlaced: 'Candidate Placed',
      lastName: 'Last Name',
      firstName: 'First Name',
      clientDetails: 'Client',
      invoiceNum: 'Invoice Number',
      salary: 'Salary',
      findersPercentage: 'Finders Percentage',
      billingAmount: 'Billing Amount',
      currencyCode: 'Currency',
      billTo: 'Bill To',
      taxesOnInvoice: 'Taxes on Invoice',
      gst: 'GST',
      hst: 'HST',
      qst: 'QST',
      outsourceAmount: 'Outsource Amount',
      outsourcePaidTo: 'Outsource Paid To',
      guarantee: 'Guarantee',
      replacementTerm: 'Replacement Term',
      paymentTerm: 'Payment Term',
      withReplacement: 'With Replacement',
      otherAgreement: 'Other Agreement',
      accountManagers: 'Account Managers',
      recruiters: 'Recruiters',
      commissionOverrides: 'Commission Overrides',
      misc: 'Misc',
      branch: 'Branch',
      division: 'Division',
      startDate: 'Start Date',
      originalStartDate: 'Original Start Date',
      clientTransfer: 'Client Transfer',
      occupation: 'Occupation',
      tesShareOfSplit: "TES' Share of Split",
      or: 'or',
      splitDescription: 'Split Description',
      paymentTerms: 'Payment Terms',
      comments: 'Comments',
      outsourceAndSplit: 'Outsource and Split',
      stakeholdersDetails: 'Stakeholders',
      miscDetails: 'Misc',
      history: 'history',
      attachments: 'attachments',
      currency: 'Currency',
      saveAsPdf: 'Save as Pdf'
    },
    listing: {
      title: 'Perm Placements',
      labels: {
        reference_number: 'Reference Number',
        invoice_number: 'Invoice #',
        name: 'Name',
        client_name: 'Client',
        start_date: 'Start Date',
        branch_name: 'Branch',
        status: 'Status'
      },
      actions: {
        titleAll: 'All Perm Placements',
        titleFiltered: 'Filtered Perm Placements'
      },
      filters: {
        title: 'Filter Perm Placements',
        startsBetweenLabel: 'Starts Between',
        startDateMin: 'Range Start',
        startDateMax: 'Range End',
        status: {
          all: 'All Statuses',
          plural: 'Statuses'
        }
      },
      errors: {
        retrievePerms: 'There was an error retrieving Perm Placements'
      }
    },
    history: {
      listing: {
        labels: {
          created_at: 'Modified Date',
          created_by_name: 'Modified By',
          status: 'Status',
          start_date: 'Start',
          createdComment: 'Comment'
        }
      }
    },
    actionButtons: {
      save: 'SAVE',
      submit: 'SUBMIT',
      process: 'PROCESS',
      reject: 'REJECT',
      cancel: 'CANCEL',
      obsolete: 'OBSOLETE',
      reopen: 'REOPEN',
      processSelected: 'PROCESS SELECTED',
      rejectSelected: 'REJECT SELECTED'
    }
  },
  contractor: {
    details: {
      title: 'Contractor Details',
      errors: {
        retrieveContractor: 'There was an error loading contractor details from the server'
      },
      message: {
        success: 'Contractor details updated successfully'
      }
    },
    labels: {
      personalDetails: 'Personal Details',
      payrollNumber: 'Payroll #',
      lastName: 'Last Name',
      firstName: 'First Name',
      preferredName: 'Preferred Name',
      entityType: 'Entity Type',
      emails: 'Emails',
      phoneNumbers: 'Phone Numbers',
      address: 'Address',
      payToName: 'Pay To Name',
      line1: 'Line 1',
      line2: 'Line 2',
      city: 'City',
      postalCode: 'Postal Code',
      province: 'Province',
      governmentNumbers: 'Government Numbers',
      sin: 'SIN',
      expires: 'Expires',
      ssn: 'SSN',
      gst: 'GST',
      qst: 'QST',
      hst: 'HST',
      supportingDocuments: 'Supporting Documents',
      aoda: 'AODA',
      signedFormOnFile: 'Signed form on file',
      orCode: 'or code',
      backcheck: 'Backcheck',
      whmis: 'WHMIS',
      whmisGhs: 'WHMIS+GHS',
      healthAndSafety: 'Health & Safety',
      workplaceViolence: 'Workplace Violence',
      miscDetails: 'Misc',
      cpp: 'CPP',
      contributing: 'Contributing',
      receiving: 'Receiving',
      active: 'Active',
      postalCodeVerified: 'Postal Code Verified',
      vaccinationStatus: 'Vaccination Status',
      vaccinationDetails: 'Additional Vaccination Details if Applicable',
      source: 'Source',
      sourceNote: 'Source Note',
      comments: 'Comments',
      externalNotes: 'External Notes',
      history: 'History',
      attachments: 'Attachments',
      newContractor: 'New Contractor',
      assignments: 'Assignments',
      contractor: 'Contractor',
      client: 'Client',
      approvers: 'Approvers',
      startDate: 'Start Date',
      stopDate: 'Stop Date',
      branch: 'Branch',
      status: 'Status',
      referenceNumber: 'Reference Number',
      supplier: 'Supplier',
      effectiveDate: 'Effective Date',
      userAccount: 'User Account',
      depositslips: 'Deposit Slips',
      invalidEffectiveDate:
        'entity or PayTo should not be changed, as the contractor has got active assignment'
    },
    history: {
      listing: {
        labels: {
          created_at: 'Modified Date',
          created_by_name: 'Modified By',
          payroll: 'Payroll #',
          name: 'Name',
          email: 'Email',
          entity: 'Entity',
          pay_to_name: 'Pay To Name',
          comment: 'Comment'
        }
      }
    }
  },
  contractors: {
    labels: {
      filter: 'Filter'
    },
    details: {
      errors: {
        save: 'There was an error saving the contractor'
      }
    },
    actions: {
      exportToXlsx: 'Export To XLSX'
    },
    listing: {
      title: 'Contractors',
      labels: {
        approvers: 'Approvers',
        branch: 'Branch',
        client: 'Client',
        contractor: 'Contractor',
        contractorName: 'Contractor',
        created_at: 'Modified Date',
        created_by_name: 'Modified By',
        created_comment: 'Comment',
        deposit_number: 'Deposit Number',
        email: 'Email',
        end_date: 'Pay Period End Date',
        entity: 'Entity',
        original_name: 'File Name',
        payrollnums: 'Payroll Numbers',
        payroll_number: 'Payroll Number',
        pay_to_name: 'Pay To Name',
        reference_number: 'Reference Number',
        startDate: 'Start Date',
        status: 'Status',
        stopDate: 'Stop Date'
      },
      errors: {
        retrieveContractors: 'There was an error retrieving the list of contractors'
      }
    }
  },
  tesEmployees: {
    filterPreference: {
      active: 'Active',
      inactive: 'Inactive',
      both: 'Both'
    },
    labels: {
      history: 'History',
      attachment: 'Attachments',
      personalDetails: 'Personal Details',
      commissionProfiles: 'Commission Profiles',
      attachments: 'Attachments',
      lastName: 'Last Name',
      firstName: 'First Name',
      preferredName: 'Preferred Name',
      branch: 'Branch',
      emails: 'Emails',
      phoneNumbers: 'Phone Numbers',
      division: 'Division',
      commission_number: 'Number',
      description: 'Description',
      newTesEmployee: 'New Tes Employee',
      roles: 'Roles',
      userAccount: 'User Account'
    },
    details: {
      title: 'TES Employees',
      errors: {
        retrieveTesEmployee: 'There was an error loading Tes Employee details from the server',
        commissionError: 'Commission Number already exists'
      },
      info: {
        saveTesEmployee: 'Employee record updated successfully',
        adminCanEdit:
          'Roles can only be edited by a System Administrator from the user account page',
        noRolesAdded: 'No roles have been added for this user'
      }
    },
    listing: {
      filters: {
        title: 'Filter Employees',
        all: 'Select Employees'
      },
      title: 'TES Employees',
      labels: {
        reference_number: 'Reference Number',
        tesEmployeeName: 'Name',
        branch_name: 'Branch',
        email: 'Email',
        roles: 'Roles',
        commissions: 'Commission #'
      },
      actions: {
        titleAll: 'All TES Employees'
      },
      errors: {
        retrieveTesEmployees: 'There was an error retrieving the list of TesEmployees'
      }
    }
  },

  advancedSearch: {
    title: 'Advanced Search',
    formWizard: {
      title: 'Select the criteria for your search results',
      subTitle: '',
      firstTabTitle: 'Which records do you want?',
      secondTabTitle: 'Input Fields',
      thirdTabTitle: 'Show only these fields'
    },
    fieldSelect: {
      showAllOptions: 'show all options'
    },
    actions: {
      printToPdf: 'Print as PDF',
      exportToExcel: 'Export to Excel',
      exportPage: 'Export this page',
      exportAll: 'Export all'
    },
    errors: {
      notAllowed: 'Action is not allowed on selected items',
      unknown: 'Error occured while updating selected items ({status})'
    },
    response: {
      success: 'success',
      bulkPdfGenerationNotification: 'PDF will be generated in the new tab'
    }
  },

  batchUpdateResults: {
    listing: {
      title: 'Batch Update Results',
      successMessage: 'The following {tolObject} have been updated',
      errorMessage: 'One or more of the following {tolObject} could not be updated',
      returnMessage:
        'You were directed to this page as a result of a prevous action. Return to that page and execute action for results'
    }
  },

  dashboard: {
    title: 'Dashboard',
    charts: {
      activeAssignmentsTimeline: {
        title: 'Active Assignments Timeline',
        xAxisLabel: 'Year',
        yAxisLabel: 'Active Assignments'
      },
      activeAssignmentsByBranch: {
        title: 'Active Assignments By Branch',
        xAxisLabel: 'Branch',
        yAxisLabel: 'Active Assignments'
      },
      contractorTypeHeadCount: {
        title: 'Contractor Head Count - Current Active Assignments',
        xAxisLabel: 'Head Count',
        yAxisLabel: 'Contractor Type'
      }
    }
  },
  clients: {
    listing: {
      title: 'Clients',
      all: 'All Clients',
      labels: {
        reference_number: 'Reference Number',
        name: 'Name',
        address: 'Default Address',
        phone: 'Phone',
        credit_check: 'Credit Check',
        type: 'Type',
        clientStatusFilter: 'Client Status',
        clientTypeFilter: 'Client Type'
      },
      filters: {
        title: 'Filter Clients',
        clientStatuses: {
          both: 'Both',
          active: 'Active',
          inactive: 'Inactive'
        },
        clientTypes: {
          both: 'Both',
          regular: 'Regular',
          endClient: 'End Client'
        }
      },
      actions: {
        new: 'New Client',
        exportToExcel: 'Export to Excel',
        exportAll: 'Export All',
        exportPage: 'Export this page'
      }
    }
  },
  client: {
    billingMethods: {
      externalSystem: 'External System',
      type: 'Type'
    },
    labels: {
      details: 'Details',
      contacts: 'Contacts',
      addresses: 'Addresses',
      attachments: 'Attachments',
      billingMethods: 'Billing Methods',
      history: 'History',
      client: 'Client',
      clientName: 'Client Name',
      clientType: 'Type',
      creditCheckDate: 'Credit Check Date',
      clientProfile: 'Active',
      assignmentRequirement: 'Assignments Require P.O. or W.A.',
      referenceNumber: 'Reference Number',
      lastName: 'Last Name',
      firstName: 'First Name',
      preferredName: 'Preferred Name',
      email: 'Email',
      phoneNumber: 'Phone Number',
      paymentTerms: 'Payment Terms',
      paymentTermUnit: 'Unit',
      additionalComment: 'Additional Comment'
    },
    history: {
      listing: {
        labels: {
          name: 'Name',
          created_at: 'Modified Date',
          created_by_name: 'Modified By',
          type: 'Type',
          credit_check: 'Credit Check'
        }
      }
    }
  },
  clientContact: {
    details: {
      clientContact: 'Client Contact'
    },
    labels: {
      details: 'Details',
      assignments: 'Assignments',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      active: 'Active',
      userAccount: 'User Account',
      client: 'Client',
      address: 'Address',
      line1: 'Line 1',
      line2: 'Line 2',
      city: 'City',
      province: 'Province',
      postalCode: 'Postal Code',
      preferredName: 'Preferred Name',
      emails: 'Emails',
      phoneNumbers: 'Phone Numbers',
      referenceNumber: 'Reference Number',
      payrollNumber: 'Payroll#',
      contractor: 'Contractor',
      users: 'Users',
      startDate: 'Start Date',
      stopDate: 'Stop Date',
      branch: 'Branch',
      status: 'Status',
      approvers: 'Approvers',
      newClientContact: 'New Client Contact'
    }
  },
  clientContacts: {
    listing: {
      labels: {
        reference_number: 'Reference Number',
        clientContactName: 'Name',
        client: 'Client',
        email: 'Email',
        phone: 'Phone',
        title: 'Client Contacts'
      },
      actions: {
        exportAll: 'Export All',
        exportPage: 'Export This Page',
        new: 'New Client Contact',
        exportToExcel: 'Export to Excel'
      },
      errors: {
        retrieveClientContacts: 'There was an error retrieving the list of Client contacts'
      },
      filters: {
        title: 'Filter Client Contacts',
        all: 'All Client Contacts',
        select: 'Select Contacts',
        activeinactive: {
          both: 'Both',
          active: 'Active',
          inactive: 'Inactive'
        }
      }
    }
  },
  supplierContacts: {
    labels: {
      filter: 'Filter',
      active: 'Active',
      inactive: 'Inactive',
      both: 'Both',
      details: 'Details',
      history: 'History',
      firstName: 'First Name',
      lastName: 'Last Name',
      preferredName: 'Preferred Name',
      supplier: 'Supplier',
      emails: 'Emails',
      phoneNumbers: 'Phone Numbers',
      userAccount: 'User Account'
    },
    listing: {
      title: 'Supplier Contacts',
      all: 'All Supplier Contacts',
      labels: {
        reference_number: 'Reference #',
        display_name: 'Name',
        supplier: 'Supplier',
        email: 'Email'
      },
      actions: {
        new: 'New Supplier Contact',
        exportToExcel: 'Export to Excel',
        exportAll: 'Export All',
        exportPage: 'Export this page'
      },
      errors: {
        retrieveSupplierContacts: 'There was an error retrieving the list of supplier contacts'
      }
    },
    details: {
      supplierContact: 'Supplier Contact'
    }
  },
  recentItems: {
    listing: {
      title: 'Recently Viewed Items',
      labels: {
        dateLastViewed: 'Date Last Viewed',
        recentItem: 'Item',
        recentItemType: 'Type'
      }
    },
    actions: {
      labels: {
        deleteRecentlyViewed: 'Delete all recently viewed items'
      }
    },
    errors: {
      deleteRecentItems: 'We encountered an error trying to delete recent item',
      retrieveRecentItems: 'There was an error retrieving recent items'
    }
  },

  users: {
    labels: {
      roles: 'User Roles',
      inactiveUser: 'This user is inactive'
    },
    listing: {
      title: 'Users',
      labels: {
        reference_number: 'Reference Number',
        username: 'Username',
        name: 'Name',
        roles: 'Additional Roles'
      },
      errors: {
        retrieveUsers: 'There was an error retrieving the list of users'
      },
      filters: {
        title: 'Filter Users',
        all: 'Select Users'
      },
      actions: {
        title: 'All Users'
      }
    }
  },

  userActivity: {
    listing: {
      labels: {
        date: 'Date',
        user: 'User',
        action: 'Action'
      }
    }
  },

  purchaseOrders: {
    listing: {
      title: 'Purchase Orders',
      labels: {
        reference_number: 'Reference Number',
        purchase_order_number: 'Number',
        client_name: 'Client',
        end_client_name: 'End Client',
        status: 'Status',
        start_date: 'Start Date',
        end_date: 'End Date',
        funds_issued: 'Funds Issued',
        funds_remaining: 'Funds Remaining',
        percentage_remaining: 'Percentage Remaining',
        type: 'Type'
      },
      filters: {
        title: 'Filter Purchase Orders',
        purchaseOrdersStatuses: {
          both: 'Both',
          active: 'Active',
          closed: 'Closed'
        },
        purchaseOrderColorTypes: {
          all: 'all',
          green: 'green',
          yellow: 'yellow',
          red: 'red'
        }
      }
    },
    assignments: {
      payRollNum: 'Payroll #',
      contractor: 'Contractor',
      client: 'Client',
      approvers: 'Approvers',
      startDate: 'Start Date',
      stopDate: 'Stop Date',
      branch: 'Branch',
      status: 'Status',
      referenceNumber: 'Reference Number'
    },
    history: {
      created_at: 'Modified Date',
      created_by_name: 'Modified By',
      status: 'Status'
    },
    fullAuditTrial: {
      created_at: 'Date & User',
      item_number: 'Item #',
      unit_price: 'Unit Price',
      quantity_delta: 'Quantity Delta',
      item_amount_remaining: 'Item Amount Remaining',
      quantity_remaining: 'Quantity Remaining',
      unit_price_delta: 'Expense Delta',
      funds_remaining_po: 'PO Funds Remaining',
      action: 'Action & Comment'
    },
    poItems: {
      item: 'Item#',
      type: 'Type',
      Region: 'Region',
      UnitPrice: 'Unit Price',
      quantityIssued: 'Quantity Issued',
      quantityRemanining: 'Quantity Remaining',
      amount: 'Amount Issued',
      amountRemanining: 'Amount Remaining',
      percentRemaining: 'Percentage Remaining'
    },
    details: {
      title: 'Purchase Order',
      assignments: 'Assignments',
      purchaseOrderDetails: 'Details',
      previousAssignments: 'Previous Assignments',
      poNumber: 'PO Number',
      clientName: 'Client',
      clientNumber: 'Client #',
      endClient: 'End-Client',
      fundsIssued: 'Funds Issued',
      fundsRemaning: 'Funds Remaining',
      startDate: 'Start Date',
      endDate: 'End Date',
      status: 'Status',
      history: 'History',
      fullAuditTrial: 'Audit Trial',
      podetails: 'PO Details',
      fullaudit: 'Audit Trail',
      filter: 'Filter',
      POStatuses: {
        Active: 'Active',
        Closed: 'Closed'
      },
      issue: 'Issue',
      save: 'Save',
      deplete: 'Deplete',
      issueFunds: 'Issue Funds',
      issueMessage: {
        message: 'To remove funds, this value should be negative.'
      },
      depleteFunds: 'Manual Depletion',
      successMessage: 'Purchase order details updated successfully',
      depleteMessage: {
        message:
          'To "undo" a depletion and increase the quantity remaining, this value should be negative.'
      },
      lineItems: 'Line Items',
      errors: {
        retrievePurchaseOrder: 'There was an error retrieving the list of purchase Orders'
      },
      warning: {
        issueFunds:
          'This will edit the funds issued, so it should not be used to manually deplete funds ',
        depleteFunds:
          'This is not the correct place for manual adjustments. Depletions are analogous to what has been billed.'
      }
    }
  },
  depositSlips: {
    listing: {
      title: 'Deposit Slips',
      depositNumber: 'Deposit Number',
      endDate: 'Pay Period End Date',
      fileName: 'File Name'
    }
  },
  payrollOverviews: {
    listing: {
      title: 'Payroll Overviews',
      labels: {
        created_at: 'Modified Date',
        created_by_name: 'Modified By',
        range_start: 'Range Start',
        range_end: 'Range End',
        departments: 'Departments',
        pay_period: 'Pay Period',
        status: 'Status'
      },
      actions: {
        titleAll: 'All payroll overviews',
        exportPage: 'Current page',
        exportAll: 'All'
      },

      errors: {
        retrievePos: 'There was an error retrieving the payroll overviews list',
        generatePos: 'There was an error generating the payroll overview',
        dateValidation: 'Please enter correct start and end dates'
      }
    },
    details: {
      title: 'Payroll  overview details',
      date_range: 'Date Range',
      departments: 'Departments',
      pay_period: 'Pay Period',
      tol_generated: 'TOL Generated',
      date: 'Date',
      user: 'User',
      timesheets: 'Timesheets',
      results: 'Results',
      processed: 'Processed',
      received: 'Received',
      ptb_processed: 'PTB Processed',
      upload_results: 'Upload below Result File',
      download_export: 'Download Export File'
    }
  },
  'payroll-overviews': {
    listing: {
      labels: {
        created_at: 'Modified Date',
        created_by_name: 'Modified By',
        range_start: 'Range Start',
        range_end: 'Range End',
        department_names: 'Departments',
        pay_period_type: 'Pay Period',
        status: 'Status'
      }
    }
  },
  reports: {
    title: 'Reports',
    labels: {
      client: 'Client'
    },
    errors: {
      run_report: 'There was an error generating the report'
    }
  },
  placementActivity: {
    title: 'Placement Activity',
    errors: {
      retrievePlacementActivity: 'Error retrieving placement activity summary.'
    }
  },
  generate: 'Generate',
  aoda: {
    successMessage: 'AODA training completed successfully'
  }
};
